// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  // demo: {
  //   title: `English`,
  //   introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  // },
  // docs: {
  //   hi: `Hi`,
  //   description: `Need help? \n Please check our docs.`,
  //   documentation: `documentation`,
  // },
  // app: `app`,
  // user: `user`,
  // list: `list`,
  // edit: `edit`,
  // shop: `shop`,
  // blog: `blog`,
  // post: `post`,
  // mail: `mail`,
  // chat: `chat`,
  // cards: `cards`,
  // posts: `posts`,
  // create: `create`,
  // kanban: `kanban`,
  // general: `general`,
  // banking: `banking`,
  // booking: `booking`,
  // profile: `profile`,
  // account: `account`,
  // product: `product`,
  // invoice: `invoice`,
  // details: `details`,
  // checkout: `checkout`,
  // calendar: `calendar`,
  // analytics: `analytics`,
  // ecommerce: `e-commerce`,
  // management: `management`,
  // menu_level: `menu level`,
  // menu_level_2a: `menu level 2a`,
  // menu_level_2b: `menu level 2b`,
  // menu_level_3a: `menu level 3a`,
  // menu_level_3b: `menu level 3b`,
  // menu_level_4a: `menu level 4a`,
  // menu_level_4b: `menu level 4b`,
  // item_disabled: `item disabled`,
  // item_label: `item label`,
  // item_caption: `item caption`,
  // item_external_link: `item external link`,
  // description: `description`,
  // other_cases: `other cases`,
  // item_by_roles: `item by roles`,
  // only_admin_can_see_this_item: `Only admin can see this item`,
};

export default en;
